import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordBillingIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
      <path
        d="M5.99997 9.82844C7.26925 9.82844 8.2973 8.97154 8.2973 7.91477C8.2973 6.85799 7.26925 5.99994 5.99997 5.99994C4.73069 5.99994 3.70264 5.14303 3.70264 4.08511C3.70264 3.02834 4.73069 2.17143 5.99997 2.17143M5.99997 9.82844C4.73069 9.82844 3.70264 8.97154 3.70264 7.91477M5.99997 9.82844V10.5946M5.99997 2.17143V1.40527M5.99997 2.17143C7.26925 2.17143 8.2973 3.02834 8.2973 4.08511"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
      />
    </svg>
  );
};
export default BordBillingIcon;
